import React from 'react';
import { Star } from 'lucide-react';
import Container from './Container';

interface Testimonial {
  content: string;
  author: string;
  role: string;
  avatar: string;
  rating: number;
}

const Testimonials: React.FC = () => {
  const testimonials: Testimonial[] = [
    {
      content: "I've always wanted to create games but had no programming experience. With Wizantix.games, I was able to build and publish my first game in just a weekend!",
      author: "Sarah Johnson",
      role: "Hobby Developer",
      avatar: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      rating: 5
    },
    {
      content: "The AI-powered tools are revolutionary. I describe what I want, and it generates functioning game mechanics that I can refine. It's cut my development time in half.",
      author: "Michael Chen",
      role: "Indie Game Developer",
      avatar: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      rating: 5
    },
    {
      content: "As a professional developer, I was skeptical, but the GDK is impressively powerful. The AI suggestions for code optimization have genuinely improved my workflow.",
      author: "Elena Rodriguez",
      role: "Senior Game Engineer",
      avatar: "https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      rating: 4
    }
  ];
  
  return (
    <section className="bg-background py-16 md:py-24">
      <Container>
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <h2 className="mb-4 text-3xl font-bold sm:text-4xl">
            What Creators Are Saying
          </h2>
          <p className="text-lg text-muted-foreground">
            Join thousands of creators who are bringing their game ideas to life with Wizantix.games.
          </p>
        </div>
        
        <div className="grid gap-8 md:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="rounded-xl border border-border bg-card p-6 shadow-sm transition-all duration-300 hover:shadow-md"
            >
              <div className="mb-4 flex">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`h-5 w-5 ${
                      i < testimonial.rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'
                    }`}
                  />
                ))}
              </div>
              
              <blockquote className="mb-6">
                <p className="text-foreground">{testimonial.content}</p>
              </blockquote>
              
              <div className="flex items-center">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.author}
                  className="mr-4 h-10 w-10 rounded-full object-cover"
                />
                <div>
                  <div className="font-medium text-foreground">{testimonial.author}</div>
                  <div className="text-sm text-muted-foreground">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Testimonials;